import { render, staticRenderFns } from "./Vidjet-pen-btn.vue?vue&type=template&id=89006a86&scoped=true&"
import script from "./Vidjet-pen-btn.vue?vue&type=script&lang=js&"
export * from "./Vidjet-pen-btn.vue?vue&type=script&lang=js&"
import style0 from "./Vidjet-pen-btn.vue?vue&type=style&index=0&id=89006a86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89006a86",
  null
  
)

export default component.exports